const ClockOutlinedBold = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.3335 3.5L3.3335 1.5M14.6668 3.5L12.6668 1.5M8.00016 5.33333V8L9.66683 9.66667M14.1668 8C14.1668 11.4058 11.4059 14.1667 8.00016 14.1667C4.59441 14.1667 1.8335 11.4058 1.8335 8C1.8335 4.59424 4.59441 1.83333 8.00016 1.83333C11.4059 1.83333 14.1668 4.59424 14.1668 8Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default ClockOutlinedBold
